// GameRuntimeProvider.tsx
import { createContext, useMemo } from "react";
import { GameRuntime } from "@/game/runtime";
import { useContext } from "react";

const GameRuntimeContext = createContext<GameRuntime | null>(null);

export const GameRuntimeProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const runtime = useMemo(() => new GameRuntime(), []);

  return (
    <GameRuntimeContext.Provider value={runtime}>
      {children}
    </GameRuntimeContext.Provider>
  );
};

export const useGameRuntime = () => {
  const runtime = useContext(GameRuntimeContext);

  if (!runtime) {
    throw new Error("useGameRuntime must be used within GameRuntimeProvider");
  }

  return runtime;
};
